import "bootstrap/js/dist/modal";

import { App } from "./App";
import BOOTSTRAP_CSS from "./styles/bootstrap-dark-purged-5.2.3.css?inline";
import CUSTOM_CSS from "./styles/extra-styles.css?inline";

import { render } from "solid-js/web";
import { ModalContextProvider } from "./context/ModalContext";
import { SHOW_MODAL_EVENT } from "./util/common";

export default function main() {
  console.clear();

  document.dispatchEvent(SHOW_MODAL_EVENT);
  window.addEventListener("error", () => console.error("Caught: Error loading page"));

  const rootContainerElementId = "mm-external-elements-container";
  if (!document.getElementById(rootContainerElementId)) {
    // create root element and mount modal
    setupElements(rootContainerElementId);
  }
}

function setupElements(rootContainerElementId: string) {
  const rootElement = document.createElement("div");
  rootElement.id = rootContainerElementId;
  document.body.append(rootElement);

  addStyles(rootElement, BOOTSTRAP_CSS, CUSTOM_CSS);

  if (import.meta.env.DEV && !(rootElement instanceof HTMLElement)) {
    throw new Error(
      "Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got mispelled?"
    );
  }

  render(
    () => (
      <ModalContextProvider>
        <App />
      </ModalContextProvider>
    ),
    rootElement
  );
}

function addStyles(containerElement: HTMLElement, ...cssStrings: string[]) {
  cssStrings.forEach((css) => {
    const blob = new Blob([css], { type: "text/css" });
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = URL.createObjectURL(blob);
    containerElement.append(link);
  });
}
